import ProductDetailAPICall from "../service/ProductDetailAPICall";
import ProductListingAPICall from "../service/ProductListingAPICall";
import ProductInventoryPriceRepository from "./ProductInventoryPriceRepository";
import _, { isArray, isObject, isString } from 'underscore';
import HomePageDocumentContentAPICall from "src/service/HomePageDocumentContentAPICall";
import { __set, __remove } from "../store/axios_indicator";
import System from "src/helper/system";
import Constants from "src/helper/Constants";

class ProductRepository {

    fetchGroupedProductsObjectBySearchParam = async (search, ManufacturerName = false, ERPPartNumbers = false, onlyGroup = false) => {
        let res = new ProductRepository().toGroupedObjectWithERPPartNumber(
            await new ProductListingAPICall().getGroupList(search, ManufacturerName, ERPPartNumbers, onlyGroup)
        );

        if (onlyGroup === true && isArray(res) && res.length > 0) {
            let g = [];
            res.map((v, i) => {
                if (v.Count === 1) {
                    g[i] = v
                }
            });
            await this.getProductPriceInventoryAssets(g)
        }

        return res
    };


    getProductDocumentImageList = async (filter, top, variantAssetSearchType, Orderby = '') => {
        return await new ProductDetailAPICall().getProductDocumentImageList({
            filter,
            top,
            variantAssetSearchType,
            Orderby
        });
    };

    getProductDocumentList = async (filter, top, orderby) => {
        return await new ProductDetailAPICall().getProductDocumentList(
            { filter, top, orderby }
        );
    };

    getAlternativeProductByVariantNumber = async (ItemNum, orderBy, top, skip) => {
        return await new ProductDetailAPICall().getAlternativeProductByVariantNumber(ItemNum, orderBy, top, skip);
    };

    getAlternativeProductCountByVariantNumber = async (ItemNum) => {
        return await new ProductDetailAPICall().getAlternativeProductCountByVariantNumber(ItemNum);
    };

    static detectStringIsItemNumber = (stringTEXT) => {
        let d = false;
        if (isString(stringTEXT)) {
            if (stringTEXT.includes('-')) {
                d = true;
            }
        }
        return d;
    };

    checkCPNAvailableInList = (cpnList, searchCPN) => {
        let selectedSearchCPN = cpnList?.find(
            (x) =>
                x?.CPN?.replace(/\s/g, "")?.toLowerCase() ==
                searchCPN?.replace(/\s/g, "")?.toLowerCase()
        );
        return selectedSearchCPN?.CPN ? selectedSearchCPN?.CPN : ''
    }

    getUniversalProductSearchList = async (searchParam) => {
        return new ProductRepository().toObjectWithItemNumber(
            await new ProductListingAPICall().getUniversalProductSearchList(searchParam)
        );
    };
    getUniversalCategoryManufacturersSearchList = async (searchParam) => {
        let res = await new ProductListingAPICall().getUniversalCategoryManufacturersSearchList(searchParam);
        return res
    };


    getProductList = async (params) => {
        return await new ProductListingAPICall().getProductsForProductListingPageList(params);
    };

    getDocumentList = async (params, isAutoSearch) => {
        return await new HomePageDocumentContentAPICall().getDocumentList(params, isAutoSearch)
    };

    getProductPriceInventoryAssets = async (objectInput, extraParams = {}) => {
        const { isPriceCall = true, isInventoryCall = true, erpMFRExists = false, isFrom = "" } = extraParams;
        let objectInputHere = [];

        if (_.isObject(objectInput) && Object.entries(objectInput).length > 0) {
            Object.entries(objectInput).map((v) => {
                let v_h = {
                    ItemNumber: v[1].ItemNumber || v[1].itemNumber,
                    ERPPartNumber: v[1].ERPPartNumber,
                    CPN: v[1].customerPartNumber ? v[1].customerPartNumber : "",
                    uniqueId: v[1].uniqueId ? v[1].uniqueId : v[1].itemNumber,
                    quantity: v[1].quantity
                };
                if (erpMFRExists)
                    v_h.ERPMFRPartNumber = v[1].ERPMFRPartNumber
                objectInputHere.push(v_h);
            });
        } else if (_.isArray(objectInput) && objectInput.length > 0) {
            objectInput.map((v) => {
                let v_h = {
                    ItemNumber: v.ItemNumber || v.itemNumber,
                    ERPPartNumber: v.ERPPartNumber,
                    CPN: v.customerPartNumber ? v.customerPartNumber : "",
                    uniqueId: v.uniqueId ? v.uniqueId : v.itemNumber,
                    quantity: v.quantity
                }
                if (erpMFRExists)
                    v_h.ERPMFRPartNumber = v.ERPMFRPartNumber
                objectInputHere.push(v_h);
            });
        }

        let productList = await this.getProductListById(objectInputHere, false, { isFrom: isFrom })
        if (isPriceCall === true || isInventoryCall === true) {
            let productCpn = [];
            objectInputHere.map((v) => {
                const _product = { ...Object.values(productList).find(f => f.ItemNumber === v.ItemNumber || f.ERPPartNumber === v.ERPPartNumber) };
                if (_product?.ItemNumber) {
                    _product.CPN = v.CPN;
                    _product.uniqueId = v.uniqueId;
                    _product.quantity = v.quantity
                    productCpn.push(_product)
                }
            });

            await this.getProductAssets(productCpn, extraParams);
        }

        return productList;
    };

    getProductAssets = async (productObj, extraParams = {}) => {
        let priceParams = [];
        let inventoryParams = [];
        __set('PRODUCT_ASSET_API_CALL');

        if (productObj) {
            const { source = "", isPriceCall = true, isInventoryCall = true, isSetPriceState = true, currency = window.mct } = extraParams;

            function setPriceParam(product) {
                if (isPriceCall) {
                    let paramSet = new ProductInventoryPriceRepository().getPricingParams(product);
                    if (paramSet) {
                        priceParams.push(paramSet)
                    }
                }
            }
            function setInventoryParam(product) {
                const invParam = new ProductInventoryPriceRepository().getInventoryParams(product);
                inventoryParams.push(invParam)
            }

            if (_.isObject(productObj) && Object.entries(productObj).length > 0) {
                Object.entries(productObj).map((v) => {
                    setPriceParam(v[1]);
                    setInventoryParam(v[1]);
                });
            } else if (productObj.length) {
                productObj.map((v) => {
                    setPriceParam(v);
                    setInventoryParam(v);
                });
            }


            if (isPriceCall && isInventoryCall) {
                await Promise.all([
                    new ProductInventoryPriceRepository().getPricingList(priceParams, true, currency),
                    new ProductInventoryPriceRepository().getInventory(inventoryParams, source)
                ]).then(() => { }).catch(() => { });
            } else {
                if (isInventoryCall) {
                    const _inv = await new ProductInventoryPriceRepository().getInventory(inventoryParams, source);
                    __remove('PRODUCT_ASSET_API_CALL');
                    return _inv;
                } else if (isPriceCall) {
                    const _price = await new ProductInventoryPriceRepository().getPricingList(priceParams, isSetPriceState, currency);
                    __remove('PRODUCT_ASSET_API_CALL');
                    return _price;
                }
            }
        }
        __remove('PRODUCT_ASSET_API_CALL');

        return true;
    }

    toGroupedObjectWithERPPartNumber(direct_res = false) {
        let b = [];
        if (direct_res && direct_res.length) {
            direct_res.map((v, i) => {
                b.push(v);
            })
        }
        return b;
    }

    toObjectWithItemNumber(direct_res = false) {
        let productList = {};
        if (direct_res && direct_res.length > 0) {
            direct_res.map((v) => {
                productList[v.ItemNumber] = v;
            });
        } else if (direct_res?.value && direct_res.value.length > 0) {
            direct_res.value.map((v) => {
                productList[v.ItemNumber] = v;
            });
        }
        return productList;
    }

    getEndCustomerByCpn(cpnList, cpn) {
        return cpnList?.length > 0 && cpnList.find(item => item.CPN === cpn)?.END
    }

    checkDesignsExist = async (params) => {
        return await new ProductDetailAPICall().checkDesignsExist(params)
    }

    getProductManufactureExternalHeading = async (params) => {
        return await new ProductDetailAPICall().getProductManufactureExternalHeading(params)
    }

    getProductListById = async (input, isProductImageInclude = false, extraParams = {}) => {
        const { isFrom = "" } = extraParams;
        let paramArr = []

        if (isObject(input) && Object.entries(input).length > 0) {
            Object.entries(input).map((v) => {
                let paramObj = {};
                if (v[1].ERPPartNumber) {
                    paramObj.ERPPartNumber = v[1].ERPPartNumber
                }
                if (v[1].ItemNumber) {
                    paramObj.ItemNumber = v[1].ItemNumber
                }
                if (v[1].ERPMFRPartNumber) {
                    paramObj.ERPMFRPartNumber = v[1].ERPMFRPartNumber
                }
                if (v[1].customerPartNumber) {
                    paramObj.selectedCPN = v[1].customerPartNumber
                }
                paramArr.push(paramObj);
            });
        } else if (isArray(input) && input.length > 0) {
            input.map((v) => {
                let paramObj = {}
                if (v.ERPPartNumber) {
                    paramObj.ERPPartNumber = v.ERPPartNumber
                }
                if (v.ItemNumber) {
                    paramObj.ItemNumber = v.ItemNumber
                }
                if (v.ERPMFRPartNumber) {
                    paramObj.ERPMFRPartNumber = v.ERPMFRPartNumber
                }
                if (v.customerPartNumber) {
                    paramObj.selectedCPN = v.customerPartNumber
                }
                paramArr.push(paramObj);
            });
        }

        const allHaveItemNumber = paramArr.every(obj => obj.hasOwnProperty('ItemNumber'));
        const allHaveERPMFRPartNumber = paramArr.every(obj => obj.hasOwnProperty('ERPMFRPartNumber'));

        let filter = "(";
        if (isFrom === Constants.systemModules.Quote) {
            let _erpPartNum = "", _erpMfrPartNum = ""

            paramArr.map((v, i) => {
                if (i > 0) {
                    _erpPartNum += `|${v.ERPPartNumber}`
                    _erpMfrPartNum += `|${v.ERPMFRPartNumber}`
                } else {
                    _erpPartNum = `${v.ERPPartNumber}`
                    _erpMfrPartNum = `${v.ERPMFRPartNumber}`
                }
            });
            filter += `distributor eq 'AVNET' and (search.in(ERPPartNumber, '${_erpPartNum}','|') or (search.in(ERPMFRPartNumber,'${_erpMfrPartNum}','|' )))`
        } else if (allHaveItemNumber) {
            paramArr.map((v, i) => {
                filter += (i > 0 ? " or " : "") + "ItemNumber eq '" + v.ItemNumber + "'" + " or Ignorecase_ItemNumber eq '" + v.ItemNumber + "'";;
            });
        } else if (allHaveERPMFRPartNumber) {
            paramArr.map((v, i) => {
                filter += (i > 0 ? " or " : "") + "ERPMFRPartNumber eq '" + v.ERPMFRPartNumber + "'";
            });
        } else {
            paramArr.map((v, i) => {
                filter += (i > 0 ? " or " : "") + "ERPPartNumber eq '" + v.ERPPartNumber + "'" + " or Ignorecase_ERPPartNumber eq '" + v.ERPPartNumber + "'";
            });
        }
        filter += ")";

        const SboatF = "Sboat eq '" + System.avUserInfoData.speedBoatAbbr + "'";

        filter = filter.trim();

        if (filter) {
            filter += ` and ${SboatF}`;
        } else {
            filter = SboatF;
        }

        let reqParam = {
            search: '*',
            top: allHaveItemNumber ? paramArr.length : paramArr.length * 3,
            isIncludeCount: true,
            isProductImageInclude: isProductImageInclude,
            isSkipFacets: true,
            filter: filter.trim(),
            isPLP: false
        }

        let res = this.toObjectWithItemNumber(
            await (await new ProductListingAPICall().getListData(reqParam)).value
        );

        // let productKey = allHaveItemNumber ? 'ItemNumber' : allHaveERPMFRPartNumber ? 'ERPMFRPartNumber' : 'ERPPartNumber'
        let productKey = allHaveItemNumber ? 'ItemNumber' : 'ERPPartNumber'
        if (isArray(input) && input.length > 0) {
            input.map((v) => {
                this.setProductObj(v, res, productKey)
            });
        }

        if (isObject(input) && Object.entries(input).length > 0) {
            Object.entries(input).map((v) => {
                this.setProductObj(v[1], res, productKey)
            });
        }
        return res
    }

    setProductObj = (inputObj, productList, productKey) => {
        let res = inputObj;
        let product = productList[res[productKey]];
        res.product = product;
        return res
    }

    sendReportErrorEmail = async (params) => {
        return await new ProductDetailAPICall().sendReportErrorEmail(params)
    }
}

export default ProductRepository;